var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JbTaskDetail',{ref:"task",attrs:{"biz-ctg":_vm.$config.BIZ_CATEGORY.FIRE},on:{"link":_vm.handleLink}})
}
var staticRenderFns = []

export { render, staticRenderFns }